import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  ({ token }, props: { applicationIcon?: string }) => ({
    wrapper: {
      marginInline: 16,
      cursor: 'pointer'
    },
    applicationIcon: {
      backgroundColor: props?.applicationIcon
    },
    navbarIcon: {
      color: token.colorWhite,
      borderRadius: 6,
      padding: 6
    },
    navbarTitle: {
      width: '100%',
      fontSize: 14,
      fontWeight: 600,
      justifyContent: 'space-between',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      '&:hover': {
        color: token.colorPrimary
      }
    },
    popoverWrapper: {
      backgroundColor: token.colorBgBase,
      width: 500,
      maxHeight: 'min(75vh, calc(100vh - 58px))',
      overflowY: 'auto',
      paddingInline: 24,
      paddingBottom: 16,
      borderRadius: 0,
      boxShadow: '0px 12px 24px rgba(3, 61, 115, 0.16)'
    },
    view: {
      marginBottom: 16,
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: token.colorBgBase,
      paddingTop: 24,
      paddingBottom: 16
    }
  })
)
